module.exports = __webpack_public_path__ + "85345e73ea6e38afd0bd9957fb81f260.png";